import React, { FunctionComponent } from "react"
import { CircularProgress } from "@material-ui/core"
import { AudioFile } from "../../typings/types"
import styles from "./AudioPlayer.module.scss"

interface AudioPlayerProps {
    audioFile?: AudioFile
    playerId: string
    loading: boolean
    error?: Error
    errorMsg?: string
    className?: string
}

export const AudioPlayer: FunctionComponent<AudioPlayerProps> = ({
    playerId,
    audioFile,
    loading,
    error,
    errorMsg,
    className
}) => {
    return (
        <>
            {loading && <CircularProgress data-testid="loading-audio" />}
            {error && <p>Audio generation failed</p>}
            {errorMsg && <p>{errorMsg}</p>}
            {audioFile && (
                <audio
                    id={playerId}
                    data-testid={playerId}
                    controls
                    controlsList="nodownload"
                    src={`data:audio/wav;base64,${audioFile.binaryData}`}
                    className={className ?? styles.AudioPlayer}
                ></audio>
            )}
        </>
    )
}
